<div class="my-2 flex flex-col flex-wrap">
  <div [attr.data-testid]="publicData()[0].testId">
    <span class="nx-font-weight-bold">{{ publicData()[0].i18n | translate }}: </span>
    {{ getData(0).mustTranslate ? (getData(0).text | translate) : getData(0).text }}
  </div>
  <div class="mt-5">
    <span class="nx-font-weight-bold">{{ 'control.data.gerl.information-on-entity' | translate }}</span>
    <div class="data-item" [attr.data-testid]="publicData()[1].testId">
      {{ publicData()[1].i18n | translate }}:
      <span class="nx-font-weight-bold">
        {{ getData(1).mustTranslate ? (getData(1).text | translate) : getData(1).text }}
      </span>
    </div>
    <div class="data-item" [attr.data-testid]="publicData()[2].testId">
      {{ publicData()[2].i18n | translate }}:
      <span class="nx-font-weight-bold">
        {{ getData(2).mustTranslate ? (getData(2).text | translate) : getData(2).text }}
      </span>
    </div>
    <div class="data-item" [attr.data-testid]="publicData()[5].testId">
      {{ publicData()[5].i18n | translate }}:
      <span class="nx-font-weight-bold">
        {{ getData(5).mustTranslate ? (getData(5).text | translate) : getData(5).text }}
      </span>
    </div>
  </div>

  <div class="mt-5">
    <span class="nx-font-weight-bold">{{ 'control.data.gerl.information-on-structure' | translate }}</span>
    <div class="data-item" [attr.data-testid]="publicData()[3].testId">
      {{ publicData()[3].i18n | translate }}:
      <span class="nx-font-weight-bold">
        {{ getData(3).mustTranslate ? (getData(3).text | translate) : getData(3).text }}
      </span>
    </div>
    <div class="data-item" [attr.data-testid]="publicData()[4].testId">
      {{ publicData()[4].i18n | translate }}:
      <span class="nx-font-weight-bold">
        {{ getData(4).mustTranslate ? (getData(4).text | translate) : getData(4).text }}
      </span>
    </div>
    <div class="data-item" [attr.data-testid]="publicData()[5].testId">
      {{ publicData()[5].i18n | translate }}:
      <span class="nx-font-weight-bold">
        @if (publicData()[5].data.at(1); as ultimateParentEHID) {
          {{ ultimateParentEHID.mustTranslate ? (ultimateParentEHID.text | translate) : ultimateParentEHID.text }}
        } @else {
          -
        }
      </span>
    </div>
  </div>
</div>
